import AdminView from "./AdminView";

export default AdminView;
